import { LayoutModule } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSnackBarModule,
  MatTabsModule,
  MatToolbarModule,
  MatTreeModule,
} from "@angular/material";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { RouterModule } from "@angular/router";

import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxPaginationModule } from "ngx-pagination";
import { AppRoutingModule } from "../app-routing.module";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { NavMenuListItemComponent } from "./components/nav-menu-list-item/nav-menu-list-item.component";
import { NavMenuComponent } from "./components/nav-menu/nav-menu.component";
import { PlnTableComponent } from "./components/pln-table/pln-table.component";
import { UserDetailsComponent } from "./components/user/components/user-details/user-details.component";
import { UserPasswordComponent } from "./components/user/components/user-password/user-password.component";
import { UserSearchComponent } from "./components/user/components/user-search/user-search.component";
import { UserRoutingModule } from "./components/user/user-routing.module";
import { UserService } from "./components/user/user.service";
import { AuthGuard } from "./guards/auth.guard";
import { ChildGuard } from "./guards/child.guard";
import { ActiveInactivePipe } from "./pipe/active-inactive.pipe";
import { DbDatePipe } from "./pipe/db-date.pipe";
import { ErrorMessageFgPipe } from "./pipe/error-message-form-group.pipe";
import { ErrorMessagePipe } from "./pipe/error-message.pipe";
import { InvetoryTypePipe } from "./pipe/invetory-type.pipe";
import { PlnTableValuePipe } from "./pipe/pln-table-value.pipe";
import { RequestStatusPipe } from "./pipe/request-status.pipe";
import { UserTypePipe } from "./pipe/user-type.pipe";
import { AuthService } from "./services/auth.service";
import { ExcelService } from "./services/excel.service";
import { NavService } from "./services/nav-menu.service";
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavMenuListItemComponent,
    NavMenuComponent,
    BreadcrumbComponent,
    PlnTableComponent,
    ErrorMessagePipe,
    ErrorMessageFgPipe,
    RequestStatusPipe,
    DbDatePipe,
    ActiveInactivePipe,
    UserTypePipe,
    InvetoryTypePipe,
    PlnTableValuePipe,
    UserSearchComponent,
    UserDetailsComponent,
    UserPasswordComponent,
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    LayoutModule,
    UserRoutingModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatBadgeModule,
    MatInputModule,
    MatMenuModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatListModule,
    MatSelectModule,
    MatRadioModule,
    MatTableModule,
    MatPaginatorModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatDividerModule,
    DragDropModule,
    MatTooltipModule,
    MatSlideToggleModule,
  ],
  exports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    LayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatGridListModule,
    MatFormFieldModule,
    MatIconModule,
    MatBadgeModule,
    MatInputModule,
    MatMenuModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatSelectModule,
    MatRadioModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatTreeModule,
    MatDividerModule,
    HeaderComponent,
    NavMenuComponent,
    NavMenuListItemComponent,
    BreadcrumbComponent,
    PlnTableComponent,
    ErrorMessagePipe,
    ErrorMessageFgPipe,
    RequestStatusPipe,
    UserTypePipe,
    InvetoryTypePipe,
    PlnTableValuePipe,
    DbDatePipe,
    ActiveInactivePipe,
    UserSearchComponent,
    UserDetailsComponent,
    UserPasswordComponent,
    NgxPaginationModule,
    DragDropModule,
    MatTooltipModule,
    MatSlideToggleModule,
  ],
  entryComponents: [],
  providers: [
    NavService,
    AuthService,
    UserService,
    AuthGuard,
    ChildGuard,
    ExcelService,
    InvetoryTypePipe,
  ],
  bootstrap: [],
})
export class SharedModule {}
